const MOCK_ID_PREFIXES = ['ord-hosp-', 'ord-asc-', 'ord-demo-', 'ord-seed-', 'ord-mock-'];
const REAL_SOURCES = new Set([
  'ai_recommendation',
  'ui',
  'integration',
  'ehr',
  'fhir',
  'fhir_export',
]);

const parseOrderDetails = order => {
  const candidates = [
    order?.orderDetails,
    order?.order_details,
    order?.description,
    order?.notes,
  ];
  for (const raw of candidates) {
    if (!raw) continue;
    if (typeof raw === 'object') return raw;
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (!trimmed) continue;
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          return JSON.parse(trimmed);
        } catch {
          continue;
        }
      }
    }
  }
  return null;
};

const getOrderTimestamp = order => {
  const raw = order?.createdAt || order?.orderedAt || order?.ordered_at;
  if (!raw) return null;
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
};

export const isMockOrder = (order, options = {}) => {
  if (!order) return false;

  const rawId = order.id || order.orderId || order.order_id;
  const id = rawId == null ? '' : String(rawId).toLowerCase();
  if (MOCK_ID_PREFIXES.some(prefix => id.startsWith(prefix))) return true;

  const source = String(order.source || order._source || '').toLowerCase();
  if (source === 'demo' || source === 'seed' || source === 'mock') return true;
  if (source && REAL_SOURCES.has(source)) return false;

  const details = parseOrderDetails(order);
  const detailsSource = String(details?.source || '').toLowerCase();
  if (detailsSource === 'demo' || detailsSource === 'seed' || detailsSource === 'mock') return true;
  if (detailsSource && REAL_SOURCES.has(detailsSource)) return false;
  if (details?.panel && (!source || source === 'manual')) return true;

  const emrLink = String(order.emrLink || '').toLowerCase();
  if (emrLink.includes('emr.example.com')) return true;

  if (options.hideManual) {
    const isManual = !source || source === 'manual';
    if (isManual) {
      if (options.allowRecent) {
        const createdAt = getOrderTimestamp(order);
        const thresholdMs = Number.isFinite(options.recentThresholdMs)
          ? options.recentThresholdMs
          : 5 * 60 * 1000;
        if (createdAt && Date.now() - createdAt.getTime() <= thresholdMs) {
          return false;
        }
      }
      return true;
    }
  }

  return false;
};

export const filterMockOrders = (orders = [], options = {}) => {
  const allowMock = options.allowMock === true;
  if (allowMock) return orders;
  return orders.filter(order => !isMockOrder(order, options));
};
